/**
 * Affiche une note sous forme d'étoiles (support des demi-notes).
 *
 * @param {number} rating - Note entre 0 et 5
 * @param {'xs'|'sm'|'md'|'lg'} size - Taille des étoiles
 * @param {string} className - Classes CSS supplémentaires
 */
const StarRating = ({ rating = 0, size = 'md', className = '' }) => {
    const sizeClasses = {
        xs: 'w-3 h-3',
        sm: 'w-4 h-4',
        md: 'w-5 h-5',
        lg: 'w-6 h-6',
    };

    const starSize = sizeClasses[size] || sizeClasses.md;
    const value = Number.isFinite(Number(rating)) ? Math.min(5, Math.max(0, Number(rating))) : 0;

    return (
        <div className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${value.toFixed(1)} sur 5`}>
            {[1, 2, 3, 4, 5].map((i) => {
                const fill = Math.min(1, Math.max(0, value - (i - 1)));

                return (
                    <span key={i} className={`relative inline-block ${starSize} shrink-0`}>
                        <svg
                            className={`absolute inset-0 ${starSize} text-gray-200`}
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            aria-hidden="true"
                        >
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                        {fill > 0 && (
                            <span
                                className="absolute inset-0 overflow-hidden"
                                style={{ width: `${fill * 100}%` }}
                            >
                                <svg
                                    className={`${starSize} text-amber-400`}
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    aria-hidden="true"
                                >
                                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                </svg>
                            </span>
                        )}
                    </span>
                );
            })}
        </div>
    );
};

export default StarRating;
